import { PiggyBank } from "lucide-react";
import { SIZES, eur } from "../../lib/shield";
import { ClubDeliveryInfo } from "./ClubDeliveryInfo";

const euro = (c) => eur(c).replace(".00", "");
const SQUAD = 20;
const FAQ = [
  ["Which orders count?", "Every shield ordered through your squad's parent link. Each sale is tracked against your squad automatically."],
  ["How is the money paid?", "Paid to your club by bank transfer when the fundraiser closes, after the single club delivery charge is taken off."],
  ["Why do you need our club's bank details?", "So funds only ever go to the club's own account. We verify the details with your club contact (treasurer, chairperson or secretary) before any transfer."],
  ["Does it cost the club anything?", "No. There's no upfront cost, no stock and nothing to collect – parents pay online for their own child's shield."],
];

export const FundraiserInfo = ({ compact = false }) => (
  <section className="space-y-5" aria-labelledby="fund-h" data-testid="fundraiser-info">
    <div className="flex items-start gap-3">
      <PiggyBank className="mt-1 h-7 w-7 shrink-0 text-lime-600" />
      <div>
        <h2 id="fund-h" className="font-display text-2xl font-black uppercase">How the fundraiser works</h2>
        <p className="mt-1 max-w-2xl text-sm text-slate-600">Every shield sold through your squad link raises money for your club. Parents pay the normal price – nothing extra – and a fixed amount from every shield goes straight to the club.</p>
      </div>
    </div>
    <div className="overflow-x-auto">
      <table className="w-full min-w-[460px] border-2 border-slate-900 bg-white text-left text-sm" data-testid="fundraiser-table">
        <thead className="bg-slate-900 text-xs uppercase tracking-wider text-white">
          <tr><th className="px-3 py-2">Shield size</th><th className="px-3 py-2">Parent pays</th><th className="px-3 py-2 text-lime-300">Club raises</th><th className="px-3 py-2">If {SQUAD} players order</th></tr>
        </thead>
        <tbody>
          {SIZES.map((s) => (
            <tr key={s.id} className="border-t border-slate-200" data-testid={`fundraiser-row-${s.id}`}>
              <td className="px-3 py-2 font-bold">{s.name}</td>
              <td className="px-3 py-2">{euro(s.price)}</td>
              <td className="px-3 py-2 font-cond text-lg font-bold text-lime-700">{euro(s.club)}</td>
              <td className="px-3 py-2 font-semibold">{euro(s.club * SQUAD)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    <p className="border-l-4 border-lime-500 bg-lime-50 px-4 py-3 text-sm" data-testid="fundraiser-example">
      <strong>Example:</strong> a squad of 20 where 12 order Medium and 8 order Large raises <strong>{euro(12 * SIZES[1].club + 8 * SIZES[2].club)}</strong> for the club. Run it across 5 squads and that's about <strong>{euro(5 * (12 * SIZES[1].club + 8 * SIZES[2].club))}</strong>.
    </p>
    <ClubDeliveryInfo />
    {!compact && (
      <dl className="grid gap-4 sm:grid-cols-2">
        {FAQ.map(([q, a]) => <div key={q}><dt className="font-bold">{q}</dt><dd className="mt-1 text-sm text-slate-600">{a}</dd></div>)}
      </dl>
    )}
  </section>
);
